import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import {
  pagingVoucherSync
} from "app/services/VoucherService";
import { PageResponse } from "app/common/Model/Shared";
import { removeListFeeToCrm } from "app/services/SyncCRMService";

export default class FeeVoidedAsyncStore {
  searchVoucherFee = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    departmentId: null,
    isSyncedToCRM: false,
    voided: true,
  };

  selectedFees = [];
  resetSelectedRows = false;
  voucherFeePage = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }

  handleSearchChange = (search) => {
    this.searchVoucherFee = { ...this.searchVoucherFee, ...search };
    this.loadVoucherFeePage();
  };

  setSelectedFees = (list) => {
    this.selectedFees = list;
  };

  loadVoucherFeePage = async () => {
    let { departmentId, ...otherData } = this.searchVoucherFee;
    if (departmentId) {
      otherData.departmentId = departmentId?.id;
    }

    return await pagingVoucherSync({ ...otherData, voided: true })
      .then(({ data }) => {
        this.voucherFeePage = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hóa đơn có lỗi");
      });
  };

  removeListFeeToCrm = async () => {
    const voucherIds = this.selectedFees?.map((el) => el?.id) || [];
    this.resetSelectedRows = !this.resetSelectedRows;

    return await removeListFeeToCrm(voucherIds)
      .then(({ data }) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectedFees = [];

        if (Array.isArray(data)) {
          const successCount = data.length;
          const total = voucherIds.length;

          if (successCount === total) {
            toast.success(`Đồng bộ thanh toán thành công: ${successCount}/${total} bản ghi`);
          } else if (successCount > 0) {
            toast.warning(`Đồng bộ thanh toán thành công một phần: ${successCount}/${total} bản ghi`);
          } else {
            toast.error("Đồng bộ thanh toán thất bại");
          }

          this.loadVoucherFeePage();
          return data;
        } else {
          toast.error("Dữ liệu trả về từ API không hợp lệ");
          return [];
        }
      })
      .catch((error) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectedFees = [];
        console.error(error);
        toast.error("Đồng bộ thanh toán có lỗi");
        return [];
      });
  };

  resetStore = () => {
    this.searchVoucherFee = {
      ...new SearchObject(),
      fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      toLastDateSync: new Date(),
      departmentId: null,
      isSyncedToCRM: false,
      voided: true,
    };
    this.selectedFees = [];
    this.voucherFeePage = new PageResponse();
  };
}
